import { isObject } from '../../../utils/helpers'

export function registerPlugin(name, config) {
  if (isObject(CKEDITOR) && isObject(CKEDITOR.plugins)) {
    try {
      CKEDITOR.plugins.add(name, config)
    } catch (ex) {
      /* istanbull ignore next */
    }
  }
}
